import { FieldOptions, Profile } from "../../../../app/user/profile/profileUtils";
import { moveObjectToEndById } from '../utils/moveObjectToEndById';
import { addOptionToFieldInGroup } from "./addFieldOptioninGroup";

const fieldWithMissingOptions = "placementYear";

/**
 * Transforms the profile by adding missing options and reordering the gender field.
 * @param {Profile} profile - The original profile object.
 * @returns {Profile} - The updated profile.
 */
export const transformProfile = (profile: Profile) => {
  // Create a deep copy of the profile object
  const updatedProfile: Profile = {
    ...profile,
  };

  // Define missing placement year options
  const missingPlacementYearOptions: FieldOptions[] = [
    { id: "1", label: 'Yes' },
    { id: "0", label: 'No' },
  ];

  // Add missing placement year options to the 'education' field
  const profileWithPlacementYearOptions = addOptionToFieldInGroup(updatedProfile, 'education', fieldWithMissingOptions, missingPlacementYearOptions);

  // Reorder options in the gender field using moveObjectToEndById
 const genderField = { ...profileWithPlacementYearOptions.fieldGroups.diversity?.fields.gender };
  const otherRefTerm = genderField.otherRefTerm;
  genderField.options = moveObjectToEndById(genderField.options, otherRefTerm);
  
  return profileWithPlacementYearOptions;
};
